export default {"src":"/_next/static/media/Step3.ea683e85.svg","height":254,"width":605,"blurWidth":0,"blurHeight":0};